import { Navigate } from "react-router-dom";

export function isAdminTokenValid() {
  const token = localStorage.getItem("admin_token");
  if (!token) return false;
  try {
    const parts = token.split(".");
    if (parts.length !== 3) return false;
    const payload = JSON.parse(atob(parts[1]));
    if (!payload.is_admin) return false;
    if (payload.exp && payload.exp * 1000 < Date.now()) {
      localStorage.removeItem("admin_token");
      return false;
    }
    return true;
  } catch {
    return false;
  }
}

export default function AdminRoute({ children }) {
  if (!isAdminTokenValid()) return <Navigate to="/admin/login" replace />;
  return children;
}
